/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const ideasDemoContent = [
  { type: 'heading', level: 1, text: 'Ideas for the home screen' },
  { type: 'heading', level: 2, text: 'Visual' },
  {
    type: 'bullets',
    items: [
      'Try a softer hero gradient on the landing panel',
      'Keep toolkit cards at two columns on tablet',
    ],
  },
  { type: 'heading', level: 2, text: 'Information architecture' },
  {
    type: 'bullets',
    items: [
      'Surface recent notes above the fold',
      'Pin Mission Control entry when a meeting is live',
    ],
  },
]
